/**
 * Handle "next" url when logging in and logging out.
 */
export default /* @ngInject */ function nextDispatcher($location, $window, $httpParamSerializer, config) {
    return function(next = $location.search().next || config.loginRedirectUrl) {
        let q = $location.search();
        if (q.client_id && q.response_type) {
            // We have all required info to redirect the user immediately to the
            // app with a valid token. This skips the redirects where we send
            // user to app without token, app sends user back to us to get a
            // token, we send user back with valid token.
            let param = $httpParamSerializer(q);
            $window.location.href = `/o/authorize/?${param}`;
        } else {
            // We don't have a client ID or response type, so we don't know
            // how to send a token to this app. Just send the user to the app
            // without a token and the app will send the user back with all
            // required info for authorization so that we can send the user
            // to the app with a valid token. https://i.imgur.com/mj0gPuT.jpg
            $window.location.href = next;
        }
    };
}



// WEBPACK FOOTER //
// ./forms/services/next-dispatcher.js